export const GraphType = {
    Line: 'line',
    Bar: 'bar',
    Pie: 'pie',
};

export const GraphScale = {
    Linear: 'linear',
    Logarithmic: 'logarithmic',
};

export interface GraphData {
    labels: string[];
    datasets: GraphDataSet[];

    label: string;
    type: typeof GraphType[keyof typeof GraphType];
    scale: typeof GraphScale[keyof typeof GraphScale];
    backgroundColor: string;
    borderColor: string;
    pointWidth: number;
    borderWidth: number;

    showLegend: boolean;
    showTooltip: boolean;

    tickRender?: ((label: string) => string);
    tooltipRender?: ((context: any) => string | string[]);
}

export interface GraphDataSet {
    label: string;
    data: number[];
    gray: boolean;
}
